// extracted by mini-css-extract-plugin
export default {"customOption":"_11f3f28fb01763da","colorLetter":"_1a8738befced6d17"};